import { Box, Typography } from "@mui/material";
import { Avatar } from "../../../../components/fieldsViews/fields/Avatar";
import { getShortName } from "../../../../utils/parseCalendarEvents";
import { BlockGapTechsProps } from "./types.nfbAssign";

export const BlockGapTechs = ({ techs }: BlockGapTechsProps) => {
    if (techs.length === 0) return null;

    return (
        <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 0.5, mb: 1, pl: "24px" }}>
            <Typography variant="caption" sx={{ color: "#9e9e9e", fontWeight: 700 }}>
                Gaps:
            </Typography>
            {techs.map((tech) => (
                <Box
                    key={tech.id}
                    sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.5,
                        backgroundColor: "#e2e8f0",
                        borderRadius: 99,
                        pl: "3px",
                        pr: 1,
                        py: "2px",
                    }}
                >
                    <Avatar value={tech.avatar} styles={{ width: 16, height: 16 }} />
                    <Typography variant="caption" sx={{ whiteSpace: "nowrap" }}>
                        {getShortName(tech.firstName, tech.lastName) ?? "Sem nome"}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};
